export default __webpack_public_path__ + "a4747d6aa2b55c5bd57dcd9965bbc374.png";